import { Button, Drawer, Link, Stack, Typography, Card, AspectRatio, CardOverflow } from '@castlery/fortress';
import { selectProduct, useGetSwatchesByProductIdQuery } from '@castlery/modules-product-domain';
import { addToCartCommandByParams } from '@castlery/modules-product-services';
import { removeItemCommand } from '@castlery/modules-order-services';
import { useAppDispatch, useAppSelector } from '@castlery/shared-redux-store';
import Image from 'next/image';
import * as React from 'react';
import { useAsyncFn } from 'react-use';
import { Delete, Add } from '@castlery/fortress/Icons';
import { selectOrderLineItems } from '@castlery/modules-order-domain';

export const FreeSwatch = () => {
  const [open, setOpen] = React.useState(false);
  const [hadShowMore, setHadShowMore] = React.useState<{ id: number; hadShow: boolean }[]>([]);
  const [swatchInProgress, setSwatchInProgress] = React.useState<number | undefined>();

  const productId = useAppSelector(selectProduct)?.id;
  const cartItems = useAppSelector(selectOrderLineItems);
  const dispatch = useAppDispatch();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { currentData, isLoading, isFetching } = useGetSwatchesByProductIdQuery(productId as number, {
    skip: !open,
  });

  // addToCartCommandByParams
  const [{ loading }, addToCartCommand] = useAsyncFn(
    async (variant_id) => {
      await dispatch(addToCartCommandByParams({ variant_id })).unwrap();
      // if (res?.error) {
      //   setErrorModalOpen(true);
      //   setErrMsg(res.error.data.errors[0].detail);
      // }
    },
    [dispatch]
  );
  const handleClickShowMore = (id: number) => {
    const temp = {
      id,
      hadShow: true,
    };
    setHadShowMore([...hadShowMore, temp]);
  };

  const judgeIfShow = (id: number, isText: boolean) => {
    let canShow = isText ? false : true;
    hadShowMore.forEach((item) => {
      if (item.id === id) {
        canShow = isText ? true : false;
      }
    });
    return canShow;
  };

  const judgeAlreadyInCart = (variantId: number) => {
    let isInCart = false;
    if (cartItems) {
      cartItems.forEach((item) => {
        if (item.variant.id === variantId) {
          isInCart = true;
        }
      });
    }
    return isInCart;
  };
  React.useEffect(() => {
    if (!loading) {
      setSwatchInProgress(undefined);
    }
  }, [loading]);

  const handleClickRemove = (variantId: number) => {
    if (cartItems) {
      cartItems.forEach((item) => {
        if (item.variant.id === variantId) {
          dispatch(removeItemCommand(item.id));
        }
      });
    }
  };

  return (
    <>
      <Link
        onClick={() => {
          setOpen(true);
        }}
        level="caption2"
      >
        Free Fabric Swatch
      </Link>
      <Drawer
        title="Add Free Fabric Swatches"
        showCloseButton
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Typography level="body2">
          Want to view the fabric before your purchase? Not a problem, we will send you up to 3 fabric swatches for
          free.
        </Typography>

        <Stack gap={2}>
          {currentData?.map((swatch) => {
            return (
              <Card>
                <Stack>
                  {/* <Avatar src={swatch} alt={swatch.name} /> */}
                  <Typography level="subh2">{swatch.presentation}</Typography>
                  <Typography level="caption2">{swatch.description}</Typography>
                  {judgeIfShow(swatch.id, false) && (
                    <Typography
                      sx={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        '&:hover': {
                          textDecoration: 'none',
                          color: (theme) => theme.palette.brand.wheat[700],
                        },
                      }}
                      onClick={() => handleClickShowMore(swatch.id)}
                    >
                      Show More
                    </Typography>
                  )}
                  {judgeIfShow(swatch.id, true) &&
                    swatch.product_properties.map((property) => {
                      return (
                        <Stack>
                          <Typography level="caption1">{property.presentation}</Typography>
                          <Typography level="caption2">{property.value}</Typography>
                        </Stack>
                      );
                    })}
                  {swatch.variants.map((variant) => {
                    return (
                      <Card
                        sx={
                          {
                            // '--Card-padding': '0px',
                          }
                        }
                      >
                        {/* <Stack key={variant.id} direction="column" gap={2} alignItems="center"> */}
                        <CardOverflow>
                          <AspectRatio>
                            {/* TODO 怎么避免这种空数组访问首个元素但是没有类型提醒的错误  */}
                            <Image src={variant.images[0]?.links.large} layout="fill" alt={variant.name} />
                          </AspectRatio>
                        </CardOverflow>
                        <Typography level="caption1">{variant.name}</Typography>
                        <CardOverflow>
                          {judgeAlreadyInCart(variant.id) ? (
                            <Button
                              fullWidth
                              disabled={loading}
                              size="sm"
                              variant="outlined"
                              onClick={() => {
                                handleClickRemove(variant.id);
                              }}
                            >
                              <>
                                <Delete fill="#fff" />
                                Tap to Remove
                              </>
                            </Button>
                          ) : (
                            <Button
                              fullWidth
                              loading={loading && swatchInProgress === variant.id}
                              disabled={loading && swatchInProgress !== variant.id}
                              size="sm"
                              variant="outlined"
                              onClick={() => {
                                setSwatchInProgress(variant.id);
                                addToCartCommand(variant.id);
                              }}
                            >
                              <>
                                <Add fill="#fff" />
                                Add to Cart
                              </>
                            </Button>
                          )}
                        </CardOverflow>
                        {/* </Stack> */}
                      </Card>
                    );
                  })}
                </Stack>
              </Card>
            );
          })}
          {open && !loading && currentData?.length === 0 && (
            <Typography
              sx={{
                mt: 4,
              }}
              level="body2"
            >
              No available swatches for this product.
            </Typography>
          )}
        </Stack>
      </Drawer>
    </>
  );
};
